import { DefaultState } from '@portal/portal-core';
import * as Types from '../types';

interface InviteResultSlice {
  open?: boolean;
  success?: boolean;
  result?: unknown;
  error?: unknown;
}

export interface AdminInvitesState {
  invites: unknown[];
  productAccessInviteUsers: InviteResultSlice;
  productAccessCancelInvites: InviteResultSlice;
}

interface AdminInvitesActionPayload {
  open?: boolean;
  success?: boolean;
  result?: unknown;
  error?: unknown;
  invites?: unknown[];
}

export const initialState: AdminInvitesState = {
  invites: [],
  productAccessInviteUsers: {},
  productAccessCancelInvites: {},
};

export function AdminInvites(
  state: AdminInvitesState = initialState,
  action: { type: string; payload?: AdminInvitesActionPayload },
): AdminInvitesState {
  const { payload } = action;
  switch (action.type) {
    case Types.CLIENT_PRODUCT_ACCESS_INVITE_USERS_RESULT:
      return {
        ...state,
        productAccessInviteUsers: {
          open: payload?.open,
          success: payload?.success,
          result: payload?.result,
          error: payload?.error,
        },
      };
    case Types.CLIENT_PRODUCT_ACCESS_INVITE_USERS_RESULT_CLEAR:
      return { ...state, productAccessInviteUsers: {} };
    case Types.CLIENT_PRODUCT_ACCESS_CANCEL_INVITES_RESULT:
      return {
        ...state,
        productAccessCancelInvites: {
          open: payload?.open,
          success: payload?.success,
          result: payload?.result,
          error: payload?.error,
        },
      };
    case Types.CLIENT_PRODUCT_ACCESS_CANCEL_INVITES_RESULT_CLEAR:
      return { ...state, productAccessCancelInvites: {} };
    case Types.CLIENT_PRODUCT_ACCESS_INVITES_SYNC:
      return { ...state, invites: payload?.invites ?? [] };
    case DefaultState.DEFAULT_STATE:
      return initialState;
    default:
      return state;
  }
}
